// @ts-nocheck
import { memo } from 'react'
import { motion } from 'framer-motion'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'

export const UserMessage = memo(function UserMessage({ message }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="flex gap-3 justify-end px-3 sm:px-4 py-3"
      data-testid={`user-message-${message.id}`}
    >
      <div className="max-w-[80%] space-y-2">
        {/* Attachments */}
        {message.attachments?.length > 0 && (
          <div className="flex justify-end flex-wrap gap-1.5" data-testid="user-attachments">
            {message.attachments.map((a, i) => (
              <span key={i} className="text-[10px] font-mono px-2 py-1 rounded-full bg-muted/50 text-muted-foreground">
                {a.name || a.filename || 'file'}
              </span>
            ))}
          </div>
        )}

        {/* Message bubble */}
        <div className="bg-primary text-primary-foreground rounded-2xl rounded-tr-md px-4 py-3">
          <p className="text-sm whitespace-pre-wrap">{message.content}</p>
        </div>
      </div>

      <div className="shrink-0 mt-1">
        <Avatar className="h-7 w-7">
          <AvatarFallback className="bg-foreground/10 text-foreground text-xs font-bold">
            U
          </AvatarFallback>
        </Avatar>
      </div>
    </motion.div>
  )
})
